import React, { useState } from "react";
import { Button, Col, message, Popconfirm, Row, Space, Table, Tooltip } from "antd";
import { FaBackwardFast } from "react-icons/fa6";
import IMAGES from "../../const/Image";
import { useNavigate } from "react-router-dom";
import { components, getRowClassName } from "../../utils/utils";

const confirm = (e) => {
  console.log(e);
  message.success("Deleted!");
};

const columns = (navigate) => [
  {
    title: "S No.",
    dataIndex: "sno",
    key: "sno",
  },
  {
    title: "Service Title",
    dataIndex: "serviceTitle",
    key: "serviceTitle",
  },
  {
    title: "Service Image",
    dataIndex: "serviceImage",
    key: "serviceImage",
  },
  {
    title: "Service Created By",
    dataIndex: "categoryCreatedBy",
    key: "categoryCreatedBy",
  },
  {
    title: "Service Status",
    dataIndex: "categoryStatus",
    key: "categoryStatus",
  },
  {
    title: "Action",
    dataIndex: "action",
    key: "action",
    render: () => (
      <Space size="middle">
        <Tooltip
          title="View Details"
          style={{ color: "red", cursor: "pointer" }}
        >
          <span
            className="action-icon-bg"
            onClick={() => navigate("/categories/details/view-service")}
          >
            <img src={IMAGES.ViewIcon} />
          </span>
        </Tooltip>
        <Tooltip title="Edit Details">
          <span
            className="action-icon-bg"
            onClick={() => navigate("/categories/details/edit-service")}
          >
            <img src={IMAGES.EditIcon} />
          </span>
        </Tooltip>
        <Popconfirm
          title="Delete the task"
          description="Are you sure to delete this task?"
          onConfirm={confirm}
          okText="Yes"
          cancelText="No"
        >
          <span className="action-icon-bg">
            <img src={IMAGES.DeleteIcon} alt="" />
          </span>
        </Popconfirm>
      </Space>
    ),
  },

];

const labList = [
  {
    id: 1,
    sno: 1,
  },
  {
    id: 2,
    sno: 2,
  },
  {
    id: 3,
    sno: 3,
  },
  {
    id: 4,
    sno: 4,
  },
  {
    id: 5,
    sno: 5,
  },
  {
    id: 6,
    sno: 6,
  },
  {
    id: 7,
    sno: 7,
  },
  {
    id: 8,
    sno: 8,
  },
  {
    id: 9,
    sno: 9,
  },
  {
    id: 10,
    sno: 10,
  },
  {
    id: 11,
    sno: 11,
  },
  {
    id: 12,
    sno: 12,
  },
  {
    id: 13,
    sno: 13,
  },
  {
    id: 14,
    sno: 14,
  },
];

export const ViewCategories = () => {
  const [loading, setloading] = useState(false);
  const navigate = useNavigate();
  const onSearch = (value, _e, info) => console.log(info?.source, value);

 

  return (
    <>
      <div className="viewCategoriesCard">
        <div className="viewCategoriesImg">
          <img
            src="https://plus.unsplash.com/premium_photo-1661963320607-aebac6fcb40d?w=500&auto=format&fit=crop&q=60&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxzZWFyY2h8MXx8aGFpciUyMHNhbG9ufGVufDB8fDB8fHww"
            alt=""
            srcset=""
          />
        </div>
        <div className="viewCategoriesDetails">
          <h1 style={{ color: "#b31217" }}>Hair Care</h1>
          <div style={{ marginTop: "15px", marginBottom: "15px" }}>
            <span className="hairCareGender">Male</span>
            <span className="hairCareGender">Female</span>
            <span className="hairCareGender">Unisex</span>
          </div>
          <h1 style={{ color: "#b31217" }}>Created By - Admin</h1>
        </div>
        <div className="viewCategoryBackBtn">
          <Button type="primary" htmlType="submit" className="addcity-btn">
            <FaBackwardFast />
          </Button>
        </div>
      </div>
      <div style={{ marginTop: "30px" }}>
        <Row gutter={[8, 8]} justify="space-between" align="middle" style={{marginBottom:'20px'}}>
          <Col>
            <h1 className="app-heading-med">Hair Care Services</h1>
          </Col>
          <Col style={{ gap: "5px" }}>
            <Button
              onClick={() => navigate("/categories/details/add-service")}
              type="primary"
              htmlType="submit"
              className="addcity-btn"
            >
              <img src={IMAGES.AddIconFilters} alt="" />
            </Button>
          </Col>
        </Row>
        <Table
          size="middle"
          bordered
          rowClassName={getRowClassName}
          components={components}
          columns={columns(navigate)}
          loading={loading}
          dataSource={labList}
        />
      </div>
     
    </>
  );
};
